import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserState } from '../../store/user/user.model';
import { AppLauncherInfo } from '../../store/appLauncher/appLauncher.model';
import {switchMap, map, take } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';

interface AppState {
  user: UserState;
  appLauncher: AppLauncherInfo
}

@Injectable({
  providedIn: 'root'
})

export class HttpRequestService {
  constructor(private http: HttpClient, private store: Store<AppState>) {}
  
  private async getEmail(): Promise<string> {
    try {
      const userEmail = await firstValueFrom(this.store.select(state => state.user.userInfo?.email));
      if (!userEmail) {
        throw new Error('User Email is null');
      }
      // Extract the username portion from the email and return
      let username: string = userEmail.split('@')[0];
      return username;
    } catch (error) {
      console.error('Failed to fetch transaction id', error);
      return 'null';
    }
  }

  private getHeaders(): Observable<HttpHeaders> {
    return this.store.select(state => 
      ({
        user: state.user,
        appLauncher: state.appLauncher
      })).pipe(
        take(1),
        switchMap(({user,appLauncher}) => {
          let headers = new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Accept', 'application/json');
            // console.log('THIS IS AppLauncher VALUE' + JSON.stringify(appLauncher))
            // Check to see if this is a request passing in API key or not (web app)
            if(appLauncher.api_key) {
              headers = headers.append('X-Api-User', appLauncher.user);
              headers = headers.append('X-Api-Key', appLauncher?.api_key);
            }
            else {
              headers = headers.append('Authorization', `Bearer ${user?.userInfo?.accessToken}`);
              headers = headers.append('X-Api-User', user?.userInfo?.email||'');
            }
        return [headers];
      })
    );
  }

  public request<T>(method: string, url: string, body?: any, params?: any): Observable<T> {
    return this.getHeaders().pipe(
      switchMap(headers => {
        // console.log('$$$$' + JSON.stringify(headers))
        const options = {
          headers,
          body,
          params
        };
        return this.http.request<T>(method, url, options);
      })
    );
  }
}